webpackJsonp([125653593147975],{

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory();
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define([], factory);
		}
		else {
			// Global (browser)
			root.CryptoJS = factory();
		}
	}(this, function () {
	
		/**
		 * CryptoJS core components.
		 */
		var CryptoJS = CryptoJS || (function (Math, undefined) {
		    /*
		     * Local polyfil of Object.create
		     */
		    var create = Object.create || (function () {
		        function F() {};
	
		        return function (obj) {
		            var subtype;
	
		            F.prototype = obj;
	
		            subtype = new F();
	
		            F.prototype = null;
	
		            return subtype;
		        };
		    }())
	
		    /**
		     * CryptoJS namespace.
		     */
		    var C = {};
	
		    /**
		     * Library namespace.
		     */
		    var C_lib = C.lib = {};
	
		    /**
		     * Base object for prototypal inheritance.
		     */
		    var Base = C_lib.Base = (function () {
	
	
		        return {
		            /**
		             * Creates a new object that inherits from this object.
		             *
		             * @param {Object} overrides Properties to copy into the new object.
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         field: 'value',
		             *
		             *         method: function () {
		             *         }
		             *     });
		             */
		            extend: function (overrides) {
		                // Spawn
		                var subtype = create(this);
	
		                // Augment
		                if (overrides) {
		                    subtype.mixIn(overrides);
		                }
	
		                // Create default initializer
		                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
		                    subtype.init = function () {
		                        subtype.$super.init.apply(this, arguments);
		                    };
		                }
	
		                // Initializer's prototype is the subtype object
		                subtype.init.prototype = subtype;
	
		                // Reference supertype
		                subtype.$super = this;
	
		                return subtype;
		            },
	
		            /**
		             * Extends this object and runs the init method.
		             * Arguments to create() will be passed to init().
		             *
		             * @return {Object} The new object.
		             *
		             * @static
		             *
		             * @example
		             *
		             *     var instance = MyType.create();
		             */
		            create: function () {
		                var instance = this.extend();
		                instance.init.apply(instance, arguments);
	
		                return instance;
		            },
	
		            /**
		             * Initializes a newly created object.
		             * Override this method to add some logic when your objects are created.
		             *
		             * @example
		             *
		             *     var MyType = CryptoJS.lib.Base.extend({
		             *         init: function () {
		             *             // ...
		             *         }
		             *     });
		             */
		            init: function () {
		            },
	
		            /**
		             * Copies properties into this object.
		             *
		             * @param {Object} properties The properties to mix in.
		             *
		             * @example
		             *
		             *     MyType.mixIn({
		             *         field: 'value'
		             *     });
		             */
		            mixIn: function (properties) {
		                for (var propertyName in properties) {
		                    if (properties.hasOwnProperty(propertyName)) {
		                        this[propertyName] = properties[propertyName];
		                    }
		                }
	
		                // IE won't copy toString using the loop above
		                if (properties.hasOwnProperty('toString')) {
		                    this.toString = properties.toString;
		                }
		            },
	
		            /**
		             * Creates a copy of this object.
		             *
		             * @return {Object} The clone.
		             *
		             * @example
		             *
		             *     var clone = instance.clone();
		             */
		            clone: function () {
		                return this.init.prototype.extend(this);
		            }
		        };
		    }());
	
		    /**
		     * An array of 32-bit words.
		     *
		     * @property {Array} words The array of 32-bit words.
		     * @property {number} sigBytes The number of significant bytes in this word array.
		     */
		    var WordArray = C_lib.WordArray = Base.extend({
		        /**
		         * Initializes a newly created word array.
		         *
		         * @param {Array} words (Optional) An array of 32-bit words.
		         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.create();
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
		         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
		         */
		        init: function (words, sigBytes) {
		            words = this.words = words || [];
	
		            if (sigBytes != undefined) {
		                this.sigBytes = sigBytes;
		            } else {
		                this.sigBytes = words.length * 4;
		            }
		        },
	
		        /**
		         * Converts this word array to a string.
		         *
		         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
		         *
		         * @return {string} The stringified word array.
		         *
		         * @example
		         *
		         *     var string = wordArray + '';
		         *     var string = wordArray.toString();
		         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
		         */
		        toString: function (encoder) {
		            return (encoder || Hex).stringify(this);
		        },
	
		        /**
		         * Concatenates a word array to this word array.
		         *
		         * @param {WordArray} wordArray The word array to append.
		         *
		         * @return {WordArray} This word array.
		         *
		         * @example
		         *
		         *     wordArray1.concat(wordArray2);
		         */
		        concat: function (wordArray) {
		            // Shortcuts
		            var thisWords = this.words;
		            var thatWords = wordArray.words;
		            var thisSigBytes = this.sigBytes;
		            var thatSigBytes = wordArray.sigBytes;
	
		            // Clamp excess bits
		            this.clamp();
	
		            // Concat
		            if (thisSigBytes % 4) {
		                // Copy one byte at a time
		                for (var i = 0; i < thatSigBytes; i++) {
		                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
		                }
		            } else {
		                // Copy one word at a time
		                for (var i = 0; i < thatSigBytes; i += 4) {
		                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
		                }
		            }
		            this.sigBytes += thatSigBytes;
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Removes insignificant bits.
		         *
		         * @example
		         *
		         *     wordArray.clamp();
		         */
		        clamp: function () {
		            // Shortcuts
		            var words = this.words;
		            var sigBytes = this.sigBytes;
	
		            // Clamp
		            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
		            words.length = Math.ceil(sigBytes / 4);
		        },
	
		        /**
		         * Creates a copy of this word array.
		         *
		         * @return {WordArray} The clone.
		         *
		         * @example
		         *
		         *     var clone = wordArray.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone.words = this.words.slice(0);
	
		            return clone;
		        },
	
		        /**
		         * Creates a word array filled with random bytes.
		         *
		         * @param {number} nBytes The number of random bytes to generate.
		         *
		         * @return {WordArray} The random word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.lib.WordArray.random(16);
		         */
		        random: function (nBytes) {
		            var words = [];
	
		            var r = (function (m_w) {
		                var m_w = m_w;
		                var m_z = 0x3ade68b1;
		                var mask = 0xffffffff;
	
		                return function () {
		                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
		                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
		                    var result = ((m_z << 0x10) + m_w) & mask;
		                    result /= 0x100000000;
		                    result += 0.5;
		                    return result * (Math.random() > .5 ? 1 : -1);
		                }
		            });
	
		            for (var i = 0, rcache; i < nBytes; i += 4) {
		                var _r = r((rcache || Math.random()) * 0x100000000);
	
		                rcache = _r() * 0x3ade67b7;
		                words.push((_r() * 0x100000000) | 0);
		            }
	
		            return new WordArray.init(words, nBytes);
		        }
		    });
	
		    /**
		     * Encoder namespace.
		     */
		    var C_enc = C.enc = {};
	
		    /**
		     * Hex encoding strategy.
		     */
		    var Hex = C_enc.Hex = {
		        /**
		         * Converts a word array to a hex string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The hex string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var hexChars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                hexChars.push((bite >>> 4).toString(16));
		                hexChars.push((bite & 0x0f).toString(16));
		            }
	
		            return hexChars.join('');
		        },
	
		        /**
		         * Converts a hex string to a word array.
		         *
		         * @param {string} hexStr The hex string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
		         */
		        parse: function (hexStr) {
		            // Shortcut
		            var hexStrLength = hexStr.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < hexStrLength; i += 2) {
		                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
		            }
	
		            return new WordArray.init(words, hexStrLength / 2);
		        }
		    };
	
		    /**
		     * Latin1 encoding strategy.
		     */
		    var Latin1 = C_enc.Latin1 = {
		        /**
		         * Converts a word array to a Latin1 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The Latin1 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            // Shortcuts
		            var words = wordArray.words;
		            var sigBytes = wordArray.sigBytes;
	
		            // Convert
		            var latin1Chars = [];
		            for (var i = 0; i < sigBytes; i++) {
		                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
		                latin1Chars.push(String.fromCharCode(bite));
		            }
	
		            return latin1Chars.join('');
		        },
	
		        /**
		         * Converts a Latin1 string to a word array.
		         *
		         * @param {string} latin1Str The Latin1 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
		         */
		        parse: function (latin1Str) {
		            // Shortcut
		            var latin1StrLength = latin1Str.length;
	
		            // Convert
		            var words = [];
		            for (var i = 0; i < latin1StrLength; i++) {
		                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
		            }
	
		            return new WordArray.init(words, latin1StrLength);
		        }
		    };
	
		    /**
		     * UTF-8 encoding strategy.
		     */
		    var Utf8 = C_enc.Utf8 = {
		        /**
		         * Converts a word array to a UTF-8 string.
		         *
		         * @param {WordArray} wordArray The word array.
		         *
		         * @return {string} The UTF-8 string.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
		         */
		        stringify: function (wordArray) {
		            try {
		                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
		            } catch (e) {
		                throw new Error('Malformed UTF-8 data');
		            }
		        },
	
		        /**
		         * Converts a UTF-8 string to a word array.
		         *
		         * @param {string} utf8Str The UTF-8 string.
		         *
		         * @return {WordArray} The word array.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
		         */
		        parse: function (utf8Str) {
		            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
		        }
		    };
	
		    /**
		     * Abstract buffered block algorithm template.
		     *
		     * The property blockSize must be implemented in a concrete subtype.
		     *
		     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
		     */
		    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
		        /**
		         * Resets this block algorithm's data buffer to its initial state.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm.reset();
		         */
		        reset: function () {
		            // Initial values
		            this._data = new WordArray.init();
		            this._nDataBytes = 0;
		        },
	
		        /**
		         * Adds new data to this block algorithm's buffer.
		         *
		         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
		         *
		         * @example
		         *
		         *     bufferedBlockAlgorithm._append('data');
		         *     bufferedBlockAlgorithm._append(wordArray);
		         */
		        _append: function (data) {
		            // Convert string to WordArray, else assume WordArray already
		            if (typeof data == 'string') {
		                data = Utf8.parse(data);
		            }
	
		            // Append
		            this._data.concat(data);
		            this._nDataBytes += data.sigBytes;
		        },
	
		        /**
		         * Processes available data blocks.
		         *
		         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
		         *
		         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
		         *
		         * @return {WordArray} The processed data.
		         *
		         * @example
		         *
		         *     var processedData = bufferedBlockAlgorithm._process();
		         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
		         */
		        _process: function (doFlush) {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
		            var dataSigBytes = data.sigBytes;
		            var blockSize = this.blockSize;
		            var blockSizeBytes = blockSize * 4;
	
		            // Count blocks ready
		            var nBlocksReady = dataSigBytes / blockSizeBytes;
		            if (doFlush) {
		                // Round up to include partial blocks
		                nBlocksReady = Math.ceil(nBlocksReady);
		            } else {
		                // Round down to include only full blocks,
		                // less the number of blocks that must remain in the buffer
		                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
		            }
	
		            // Count words ready
		            var nWordsReady = nBlocksReady * blockSize;
	
		            // Count bytes ready
		            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);
	
		            // Process blocks
		            if (nWordsReady) {
		                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
		                    // Perform concrete-algorithm logic
		                    this._doProcessBlock(dataWords, offset);
		                }
	
		                // Remove processed words
		                var processedWords = dataWords.splice(0, nWordsReady);
		                data.sigBytes -= nBytesReady;
		            }
	
		            // Return processed words
		            return new WordArray.init(processedWords, nBytesReady);
		        },
	
		        /**
		         * Creates a copy of this object.
		         *
		         * @return {Object} The clone.
		         *
		         * @example
		         *
		         *     var clone = bufferedBlockAlgorithm.clone();
		         */
		        clone: function () {
		            var clone = Base.clone.call(this);
		            clone._data = this._data.clone();
	
		            return clone;
		        },
	
		        _minBufferSize: 0
		    });
	
		    /**
		     * Abstract hasher template.
		     *
		     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
		     */
		    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
		        /**
		         * Configuration options.
		         */
		        cfg: Base.extend(),
	
		        /**
		         * Initializes a newly created hasher.
		         *
		         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
		         *
		         * @example
		         *
		         *     var hasher = CryptoJS.algo.SHA256.create();
		         */
		        init: function (cfg) {
		            // Apply config defaults
		            this.cfg = this.cfg.extend(cfg);
	
		            // Set initial values
		            this.reset();
		        },
	
		        /**
		         * Resets this hasher to its initial state.
		         *
		         * @example
		         *
		         *     hasher.reset();
		         */
		        reset: function () {
		            // Reset data buffer
		            BufferedBlockAlgorithm.reset.call(this);
	
		            // Perform concrete-hasher logic
		            this._doReset();
		        },
	
		        /**
		         * Updates this hasher with a message.
		         *
		         * @param {WordArray|string} messageUpdate The message to append.
		         *
		         * @return {Hasher} This hasher.
		         *
		         * @example
		         *
		         *     hasher.update('message');
		         *     hasher.update(wordArray);
		         */
		        update: function (messageUpdate) {
		            // Append
		            this._append(messageUpdate);
	
		            // Update the hash
		            this._process();
	
		            // Chainable
		            return this;
		        },
	
		        /**
		         * Finalizes the hash computation.
		         * Note that the finalize operation is effectively a destructive, read-once operation.
		         *
		         * @param {WordArray|string} messageUpdate (Optional) A final message update.
		         *
		         * @return {WordArray} The hash.
		         *
		         * @example
		         *
		         *     var hash = hasher.finalize();
		         *     var hash = hasher.finalize('message');
		         *     var hash = hasher.finalize(wordArray);
		         */
		        finalize: function (messageUpdate) {
		            // Final message update
		            if (messageUpdate) {
		                this._append(messageUpdate);
		            }
	
		            // Perform concrete-hasher logic
		            var hash = this._doFinalize();
	
		            return hash;
		        },
	
		        blockSize: 512/32,
	
		        /**
		         * Creates a shortcut function to a hasher's object interface.
		         *
		         * @param {Hasher} hasher The hasher to create a helper for.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
		         */
		        _createHelper: function (hasher) {
		            return function (message, cfg) {
		                return new hasher.init(cfg).finalize(message);
		            };
		        },
	
		        /**
		         * Creates a shortcut function to the HMAC's object interface.
		         *
		         * @param {Hasher} hasher The hasher to use in this HMAC helper.
		         *
		         * @return {Function} The shortcut function.
		         *
		         * @static
		         *
		         * @example
		         *
		         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
		         */
		        _createHmacHelper: function (hasher) {
		            return function (message, key) {
		                return new C_algo.HMAC.init(hasher, key).finalize(message);
		            };
		        }
		    });
	
		    /**
		     * Algorithm namespace.
		     */
		    var C_algo = C.algo = {};
	
		    return C;
		}(Math));
	
	
		return CryptoJS;
	
	}));

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	;(function (root, factory) {
		if (true) {
			// CommonJS
			module.exports = exports = factory(__webpack_require__(121));
		}
		else if (typeof define === "function" && define.amd) {
			// AMD
			define(["./core"], factory);
		}
		else {
			// Global (browser)
			factory(root.CryptoJS);
		}
	}(this, function (CryptoJS) {
	
		(function (Math) {
		    // Shortcuts
		    var C = CryptoJS;
		    var C_lib = C.lib;
		    var WordArray = C_lib.WordArray;
		    var Hasher = C_lib.Hasher;
		    var C_algo = C.algo;
	
		    // Initialization and round constants tables
		    var H = [];
		    var K = [];
	
		    // Compute constants
		    (function () {
		        function isPrime(n) {
		            var sqrtN = Math.sqrt(n);
		            for (var factor = 2; factor <= sqrtN; factor++) {
		                if (!(n % factor)) {
		                    return false;
		                }
		            }
	
		            return true;
		        }
	
		        function getFractionalBits(n) {
		            return ((n - (n | 0)) * 0x100000000) | 0;
		        }
	
		        var n = 2;
		        var nPrime = 0;
		        while (nPrime < 64) {
		            if (isPrime(n)) {
		                if (nPrime < 8) {
		                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
		                }
		                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));
	
		                nPrime++;
		            }
	
		            n++;
		        }
		    }());
	
		    // Reusable object
		    var W = [];
	
		    /**
		     * SHA-256 hash algorithm.
		     */
		    var SHA256 = C_algo.SHA256 = Hasher.extend({
		        _doReset: function () {
		            this._hash = new WordArray.init(H.slice(0));
		        },
	
		        _doProcessBlock: function (M, offset) {
		            // Shortcut
		            var H = this._hash.words;
	
		            // Working variables
		            var a = H[0];
		            var b = H[1];
		            var c = H[2];
		            var d = H[3];
		            var e = H[4];
		            var f = H[5];
		            var g = H[6];
		            var h = H[7];
	
		            // Computation
		            for (var i = 0; i < 64; i++) {
		                if (i < 16) {
		                    W[i] = M[offset + i] | 0;
		                } else {
		                    var gamma0x = W[i - 15];
		                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
		                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
		                                   (gamma0x >>> 3);
	
		                    var gamma1x = W[i - 2];
		                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
		                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
		                                   (gamma1x >>> 10);
	
		                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
		                }
	
		                var ch  = (e & f) ^ (~e & g);
		                var maj = (a & b) ^ (a & c) ^ (b & c);
	
		                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
		                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));
	
		                var t1 = h + sigma1 + ch + K[i] + W[i];
		                var t2 = sigma0 + maj;
	
		                h = g;
		                g = f;
		                f = e;
		                e = (d + t1) | 0;
		                d = c;
		                c = b;
		                b = a;
		                a = (t1 + t2) | 0;
		            }
	
		            // Intermediate hash value
		            H[0] = (H[0] + a) | 0;
		            H[1] = (H[1] + b) | 0;
		            H[2] = (H[2] + c) | 0;
		            H[3] = (H[3] + d) | 0;
		            H[4] = (H[4] + e) | 0;
		            H[5] = (H[5] + f) | 0;
		            H[6] = (H[6] + g) | 0;
		            H[7] = (H[7] + h) | 0;
		        },
	
		        _doFinalize: function () {
		            // Shortcuts
		            var data = this._data;
		            var dataWords = data.words;
	
		            var nBitsTotal = this._nDataBytes * 8;
		            var nBitsLeft = data.sigBytes * 8;
	
		            // Add padding
		            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
		            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
		            data.sigBytes = dataWords.length * 4;
	
		            // Hash final blocks
		            this._process();
	
		            // Return final computed hash
		            return this._hash;
		        },
	
		        clone: function () {
		            var clone = Hasher.clone.call(this);
		            clone._hash = this._hash.clone();
	
		            return clone;
		        }
		    });
	
		    /**
		     * Shortcut function to the hasher's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     *
		     * @return {WordArray} The hash.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hash = CryptoJS.SHA256('message');
		     *     var hash = CryptoJS.SHA256(wordArray);
		     */
		    C.SHA256 = Hasher._createHelper(SHA256);
	
		    /**
		     * Shortcut function to the HMAC's object interface.
		     *
		     * @param {WordArray|string} message The message to hash.
		     * @param {WordArray|string} key The secret key.
		     *
		     * @return {WordArray} The HMAC.
		     *
		     * @static
		     *
		     * @example
		     *
		     *     var hmac = CryptoJS.HmacSHA256(message, key);
		     */
		    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
		}(Math));
	
	
		return CryptoJS.SHA256;
	
	}));

/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GlobalFunctions = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Complete = function (_React$Component) {
		(0, _inherits3.default)(Complete, _React$Component);
	
		function Complete() {
			(0, _classCallCheck3.default)(this, Complete);
			return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
		}
	
		Complete.prototype.componentDidMount = function componentDidMount() {
			var wrapper = document.getElementById('forgotFormContainer');
			(0, _GlobalFunctions.addClass)(wrapper, 'form-wrapper-finish');
		};
	
		Complete.prototype.render = function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'form-error form-error__finish' },
				_react2.default.createElement(
					'p',
					{ className: 'info' },
					'Your password has been successfully changed.'
				),
				_react2.default.createElement(
					'p',
					{ className: 'info' },
					'You can now proceed to login to your membership area.'
				)
			);
		};
	
		return Complete;
	}(_react2.default.Component);
	
	exports.default = Complete;
	module.exports = exports['default'];

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Step = __webpack_require__(484);
	
	var _Step2 = _interopRequireDefault(_Step);
	
	var _Step3 = __webpack_require__(485);
	
	var _Step4 = _interopRequireDefault(_Step3);
	
	var _Complete = __webpack_require__(192);
	
	var _Complete2 = _interopRequireDefault(_Complete);
	
	var _navigation = __webpack_require__(13);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(12);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _registerNowLeft = __webpack_require__(23);
	
	var _registerNowLeft2 = _interopRequireDefault(_registerNowLeft);
	
	var _reactRouterDom = __webpack_require__(42);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RecoveryFormStep1 = function (_React$Component) {
		(0, _inherits3.default)(RecoveryFormStep1, _React$Component);
	
		function RecoveryFormStep1(props) {
			(0, _classCallCheck3.default)(this, RecoveryFormStep1);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
			_this._nextStep = _this._nextStep.bind(_this);
			_this._prevStep = _this._prevStep.bind(_this);
			_this._setStep1 = _this._setStep1.bind(_this);
			_this._setStep2 = _this._setStep2.bind(_this);
			_this.state = {
				step: 1,
				email: '',
				hash: '',
				error: '',
				hasHash: false
			};
			return _this;
		}
	
		RecoveryFormStep1.prototype._getCurrentStep = function _getCurrentStep() {
			switch (this.state.step) {
				case 1:
					return _react2.default.createElement(_Step2.default, {
						message: "The recovery link has been sent to the e-mail address you have indicated. Please, follow the link e-mailed or enter the verification code manually. Please note that it can take some time for the e-mail to arrive.",
						error: this.state.error,
						setData: this._setStep1,
						nextStep: this._nextStep });
				case 2:
					return _react2.default.createElement(_Step4.default, {
						hash: this.state.hash,
						hasHash: this.state.hasHash,
						setData: this._setStep2,
						prevStep: this._prevStep,
						nextStep: this._nextStep });
				case 3:
					return _react2.default.createElement(_Complete2.default, null);
	
				default:
					throw 'Invalid Step';
			}
		};
	
		RecoveryFormStep1.prototype._nextStep = function _nextStep() {
			this.setState({ step: this.state.step + 1 });
		};
	
		RecoveryFormStep1.prototype._prevStep = function _prevStep() {
			this.setState({ step: this.state.step - 1 });
		};
	
		RecoveryFormStep1.prototype._setStep1 = function _setStep1(e) {
			this.setState({ email: e.state.email });
			this.setState({ hash: e.state.hash });
		};
	
		RecoveryFormStep1.prototype._setStep2 = function _setStep2(e) {
			this.setState({ error: e.state.error });
		};
	
		RecoveryFormStep1.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				this._getCurrentStep.call(this)
			);
		};
	
		return RecoveryFormStep1;
	}(_react2.default.Component);
	
	var RecoveryFormStep2 = function (_React$Component2) {
		(0, _inherits3.default)(RecoveryFormStep2, _React$Component2);
	
		function RecoveryFormStep2(props) {
			(0, _classCallCheck3.default)(this, RecoveryFormStep2);
	
			var _this2 = (0, _possibleConstructorReturn3.default)(this, _React$Component2.call(this, props));
	
			_this2._nextStep = _this2._nextStep.bind(_this2);
			_this2._prevStep = _this2._prevStep.bind(_this2);
			_this2._setStep1 = _this2._setStep1.bind(_this2);
			_this2._setStep2 = _this2._setStep2.bind(_this2);
			_this2.state = {
				step: 2,
				hash: props.match.params.emailhash.replace('.html', ''),
				error: '',
				hasHash: true
			};
			return _this2;
		}
	
		RecoveryFormStep2.prototype._getCurrentStep = function _getCurrentStep() {
			switch (this.state.step) {
				case 1:
					return _react2.default.createElement(_Step2.default, {
						message: "The recovery link has been sent to the e-mail address you have indicated. Please, follow the link e-mailed or enter the verification code manually. Please note that it can take some time for the e-mail to arrive.",
						error: this.state.error,
						setData: this._setStep1,
						nextStep: this._nextStep });
				case 2:
					return _react2.default.createElement(_Step4.default, {
						hash: this.state.hash,
						hasHash: this.state.hasHash,
						setData: this._setStep2,
						prevStep: this._prevStep,
						nextStep: this._nextStep });
				case 3:
					return _react2.default.createElement(_Complete2.default, null);
	
				default:
					throw 'Invalid Step';
			}
		};
	
		RecoveryFormStep2.prototype._nextStep = function _nextStep() {
			this.setState({ step: this.state.step + 1 });
		};
	
		RecoveryFormStep2.prototype._prevStep = function _prevStep() {
			this.setState({ step: this.state.step - 1 });
		};
	
		RecoveryFormStep2.prototype._setStep1 = function _setStep1(e) {
			this.setState({ email: e.state.email });
			this.setState({ hash: e.state.hash });
		};
	
		RecoveryFormStep2.prototype._setStep2 = function _setStep2(e) {
			this.setState({ error: e.state.error });
		};
	
		RecoveryFormStep2.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				this._getCurrentStep.call(this)
			);
		};
	
		return RecoveryFormStep2;
	}(_react2.default.Component);
	
	var Recovery = function (_React$Component3) {
		(0, _inherits3.default)(Recovery, _React$Component3);
	
		function Recovery() {
			(0, _classCallCheck3.default)(this, Recovery);
			return (0, _possibleConstructorReturn3.default)(this, _React$Component3.apply(this, arguments));
		}
	
		Recovery.prototype.pageClick = function pageClick(e) {
			document.getElementsByTagName('body')[0].className = '';
		};
	
		Recovery.prototype.componentDidMount = function componentDidMount() {
			var self = this,
			    mask = document.getElementById('mask');
			mask.addEventListener('touchstart', self.pageClick, false);
		};
	
		Recovery.prototype.render = function render() {
	
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: "Remote academic writers needed. Freelance job for retired, students, teachers and freelance writers - UvoCorp.com",
					meta: [{ name: "description", content: "Online Freelance Writing Jobs, Freelance Writer Needed, Jobs for Writers" }, { name: "robots", content: "noindex,nofollow" }],
					link: [{ rel: 'canonical', href: "https://www.uvocorp.com/recovery_password/" }] }),
				_react2.default.createElement(
					"div",
					{ className: "header", id: "header" },
					_react2.default.createElement(_navigation2.default, null)
				),
				_react2.default.createElement(
					"div",
					{ className: "wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "inner-white" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "form-container recovery" },
								_react2.default.createElement(
									"h1",
									{ className: "form-header" },
									"Recovery password"
								),
								_react2.default.createElement(
									"div",
									{ className: "form-wrapper", id: "forgotFormContainer" },
									_react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/recovery_password", component: RecoveryFormStep1 }),
									_react2.default.createElement(_reactRouterDom.Route, { path: "/recovery_password/:emailhash", component: RecoveryFormStep2 })
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-registration inner-registration-left" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-image" },
								_react2.default.createElement(
									"div",
									{ className: "img inner-registration-img" },
									_react2.default.createElement("img", { src: _registerNowLeft2.default, alt: "Start registration" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-text" },
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-title" },
									"Register now ",
									_react2.default.createElement("br", null),
									"to start earning!"
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-button" },
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: "/register_email.html" },
										"Start registration"
									)
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				),
				_react2.default.createElement("div", { id: "mask", className: "c-mask" })
			);
		};
	
		return Recovery;
	}(_react2.default.Component);
	
	exports.default = Recovery;
	module.exports = exports["default"];

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GlobalFunctions = __webpack_require__(24);
	
	var _SingleInput = __webpack_require__(35);
	
	var _SingleInput2 = _interopRequireDefault(_SingleInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Step1 = function (_React$Component) {
		(0, _inherits3.default)(Step1, _React$Component);
	
		function Step1(props) {
			(0, _classCallCheck3.default)(this, Step1);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
			_this.onInputFocus = _this.onInputFocus.bind(_this);
			_this.handleCodeChange = _this.handleCodeChange.bind(_this);
			_this.checkForm = _this.checkForm.bind(_this);
			_this.state = {
				email: '',
				hash: '',
	
				recoveryError: _this.props.error ? '<p>' + _this.props.error + '</p>' : '',
				recoveryDisabled: false
			};
			return _this;
		}
	
		Step1.prototype.handleCodeChange = function handleCodeChange(e) {
			if (/^[a-zA-Z0-9]*$/.test(e.target.value)) {
				this.setState({ hash: e.target.value });
			} else {
				this.setState({ recoveryError: '<p>Invalid characters</p>' });
			}
		};
	
		Step1.prototype.onInputFocus = function onInputFocus(s) {
			(0, _GlobalFunctions.addClass)(s.target.parentNode, "input--filled"), this.setState({ recoveryError: '' });
		};
	
		Step1.prototype.onInputBlur = function onInputBlur(s) {
			"" === s.target.value.trim() && (0, _GlobalFunctions.removeClass)(s.target.parentNode, "input--filled");
		};
	
		Step1.prototype.checkForm = function checkForm(e) {
			e.preventDefault();
	
			var self = this;
	
			self.setState({ recoveryDisabled: true, recoveryError: '' });
			if (self.state.hash !== '') {
				self.props.setData(self);
				self.props.nextStep.call(this);
			} else {
				self.setState({ recoveryDisabled: false, recoveryError: '<p>Enter your verification code from email!</p>' });
			}
		};
	
		Step1.prototype.componentDidMount = function componentDidMount() {
			for (var fieldList = document.querySelectorAll(".input__field"), i = 0; i < fieldList.length; i++) {
				"" !== fieldList[i].value.trim() && (0, _GlobalFunctions.addClass)(fieldList[i].parentNode, "input--filled");
			}
		};
	
		Step1.prototype.render = function render() {
			return _react2.default.createElement(
				'form',
				{ id: 'forgotForm', className: 'form', onSubmit: this.checkForm },
				_react2.default.createElement(
					'div',
					{ className: 'form-info' },
					this.props.message
				),
				_react2.default.createElement('div', { id: 'forgotError', className: 'form-error', dangerouslySetInnerHTML: { __html: this.state.recoveryError } }),
				_react2.default.createElement(_SingleInput2.default, {
					inputType: 'text',
					title: 'Your verification code from email',
					name: 'forgotEmailCode',
					content: this.state.emailcode,
					controlFunc: this.handleCodeChange,
					placeholder: 'Enter your verification code',
					focusFunc: this.onInputFocus,
					blurFunc: this.onInputBlur,
					svg: 'M14.9,12.7c-0.2,0-0.7-0.6-0.9-0.8l-0.6,0.6l1.5,1.5c0.1,0.1,0.2,0.3,0.2,0.5c0,0.4-0.4,0.8-0.8,0.8 c-0.2,0-0.3-0.1-0.5-0.2l-4.5-4.5c-0.7,0.5-1.6,0.9-2.4,0.9c-1.5,0-2.5-1-2.5-2.5c0-2.2,2.2-4.4,4.4-4.4c1.5,0,2.5,1,2.5,2.5 c0,0.9-0.4,1.7-0.9,2.4l2.4,2.4l0.6-0.6c-0.1-0.1-0.8-0.7-0.8-0.9c0-0.2,0.6-0.8,0.8-0.8c0.1,0,0.1,0,0.2,0.1 c0.2,0.2,2.1,2,2.1,2.2C15.6,12.1,15,12.7,14.9,12.7z M8.7,6C7.9,6,7.4,6.5,7.4,7.2c0,0.2,0,0.4,0.1,0.6C7.3,7.7,7.1,7.7,6.9,7.7 C6.2,7.7,5.6,8.2,5.6,9s0.6,1.3,1.3,1.3S8.2,9.7,8.2,9c0-0.2,0-0.4-0.1-0.6c0.2,0.1,0.4,0.1,0.6,0.1c0.7,0,1.3-0.6,1.3-1.3 S9.4,6,8.7,6z',
					required: true }),
				_react2.default.createElement(
					'div',
					{ className: 'form-row form-row-submit' },
					_react2.default.createElement('input', { id: 'forgotSubmit', className: 'form-submit', type: 'submit', value: 'Send', disabled: this.state.recoveryDisabled })
				)
			);
		};
	
		return Step1;
	}(_react2.default.Component);
	
	exports.default = Step1;
	module.exports = exports['default'];

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _GlobalFunctions = __webpack_require__(24);
	
	var _SingleInput = __webpack_require__(35);
	
	var _SingleInput2 = _interopRequireDefault(_SingleInput);
	
	var _sha = __webpack_require__(122);
	
	var _sha2 = _interopRequireDefault(_sha);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Step2 = function (_React$Component) {
		(0, _inherits3.default)(Step2, _React$Component);
	
		function Step2(props) {
			(0, _classCallCheck3.default)(this, Step2);
	
			var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
			_this.onInputFocus = _this.onInputFocus.bind(_this);
			_this.handlePassChange = _this.handlePassChange.bind(_this);
			_this.handlePass2Change = _this.handlePass2Change.bind(_this);
			_this.checkForm = _this.checkForm.bind(_this);
			_this.state = {
				visible: false,
				error: '',
				pass1: '',
				pass2: '',
				hasHash: props.hasHash,
	
				recoveryError: '',
				recoveryDisabled: false
			};
			return _this;
		}
	
		Step2.prototype.handlePassChange = function handlePassChange(e) {
			this.setState({ pass1: e.target.value });
		};
	
		Step2.prototype.handlePass2Change = function handlePass2Change(e) {
			this.setState({ pass2: e.target.value });
		};
	
		Step2.prototype.onInputFocus = function onInputFocus(s) {
			(0, _GlobalFunctions.addClass)(s.target.parentNode, "input--filled"), this.setState({ recoveryError: '' });
		};
	
		Step2.prototype.onInputBlur = function onInputBlur(s) {
			"" === s.target.value.trim() && (0, _GlobalFunctions.removeClass)(s.target.parentNode, "input--filled");
		};
	
		Step2.prototype.checkForm = function checkForm(e) {
			e.preventDefault();
			var self = this;
	
			self.setState({ recoveryDisabled: true, recoveryError: '' });
	
			(0, _GlobalFunctions.getJSON_and_status)('POST', '/api/password/recovery', 'hash=' + self.props.hash + '&pass1=' + (0, _sha2.default)(self.state.pass1) + '&pass2=' + (0, _sha2.default)(self.state.pass2), function (data) {
	
				self.props.nextStep.call(this);
			}, function (error, status) {
				var statusArray = JSON.parse(error);
	
				if (status === 400) {
					if (statusArray.fields && statusArray.fields !== 'undefined') {
						var forgotErrorFields = '';
						if (statusArray.fields.length > 0) {
							for (var i = 0; i < statusArray.fields.length; i++) {
								forgotErrorFields += statusArray.fields[i] + '\n';
							}
						}
						self.setState({ error: forgotErrorFields });
					} else if (statusArray.message && statusArray.message !== 'undefined') {
						self.setState({ error: statusArray.message });
					}
					self.props.setData(self);
					self.props.prevStep.call(self);
				} else {
					if (statusArray.fields && statusArray.fields !== 'undefined') {
						var forgotErrorFields = '';
						if (statusArray.fields.length > 0) {
							for (var i = 0; i < statusArray.fields.length; i++) {
								forgotErrorFields += '<p>' + statusArray.fields[i] + '</p>';
							}
						}
						self.setState({ recoveryError: forgotErrorFields });
					} else if (statusArray.message && statusArray.message !== 'undefined') {
						self.setState({ recoveryError: '<p>' + statusArray.message + '</p>' });
					}
					self.setState({ recoveryDisabled: false });
				}
			});
		};
	
		Step2.prototype.componentWillMount = function componentWillMount() {
	
			var self = this;
			if (self.state.hasHash) {
				if (self.state.hasHash !== '') {
					self.setState({ visible: true });
				} else {
					self.setState({ error: 'Enter your verification code from email!' });
					self.props.setData(self);
					self.props.prevStep.call(this);
				}
			} else {
				self.setState({ visible: true });
			}
		};
	
		Step2.prototype.componentDidMount = function componentDidMount() {
			for (var fieldList = document.querySelectorAll(".input__field"), i = 0; i < fieldList.length; i++) {
				"" !== fieldList[i].value.trim() && (0, _GlobalFunctions.addClass)(fieldList[i].parentNode, "input--filled");
			}
		};
	
		Step2.prototype.render = function render() {
			if (this.state && this.state.visible) {
				return _react2.default.createElement(
					'form',
					{ id: 'forgotForm', className: 'form', onSubmit: this.checkForm },
					_react2.default.createElement(
						'div',
						{ className: 'form-info' },
						this.props.message
					),
					_react2.default.createElement('div', { id: 'forgotError', className: 'form-error', dangerouslySetInnerHTML: { __html: this.state.recoveryError } }),
					_react2.default.createElement(
						'div',
						{ className: 'form-row', title: 'Your new password' },
						_react2.default.createElement('input', {
							className: 'form-input input__field',
							name: 'forgotNewPassword',
							type: 'password',
							value: this.state.pass1,
							required: true,
							onChange: this.handlePassChange,
							onFocus: this.onInputFocus,
							onBlur: this.onInputBlur,
							placeholder: 'Enter your new password',
							pattern: '.{5,}',
							title: 'Minimum 5 characters required' }),
						_react2.default.createElement(
							'svg',
							{ viewBox: '0 0 20 20' },
							_react2.default.createElement('path', { fill: '#D2D2D2', d: 'M14.8,15.1c0,0.4-0.4,0.8-0.8,0.8H6c-0.4,0-0.8-0.4-0.8-0.8v-4.8c0-0.4,0.4-0.8,0.8-0.8h0.3V7.9c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8v1.6H14c0.4,0,0.8,0.4,0.8,0.8V15.1z M12.1,9.5V7.9c0-1.2-1-2.1-2.1-2.1s-2.1,1-2.1,2.1v1.6H12.1z' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form-row', title: 'Repeat your new password' },
						_react2.default.createElement('input', {
							className: 'form-input input__field',
							name: 'forgotNewPassword',
							type: 'password',
							value: this.state.pass2,
							required: true,
							onChange: this.handlePass2Change,
							onFocus: this.onInputFocus,
							onBlur: this.onInputBlur,
							placeholder: 'Retype your new password',
							pattern: '.{5,}',
							title: 'Minimum 5 characters required' }),
						_react2.default.createElement(
							'svg',
							{ viewBox: '0 0 20 20' },
							_react2.default.createElement('path', { fill: '#D2D2D2', d: 'M14.8,15.1c0,0.4-0.4,0.8-0.8,0.8H6c-0.4,0-0.8-0.4-0.8-0.8v-4.8c0-0.4,0.4-0.8,0.8-0.8h0.3V7.9c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8v1.6H14c0.4,0,0.8,0.4,0.8,0.8V15.1z M12.1,9.5V7.9c0-1.2-1-2.1-2.1-2.1s-2.1,1-2.1,2.1v1.6H12.1z' })
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'form-row form-row-submit' },
						_react2.default.createElement('input', { id: 'forgotSubmit', className: 'form-submit', type: 'submit', value: 'Send', disabled: this.state.recoveryDisabled })
					)
				);
			} else {
				return null;
			}
		};
	
		return Step2;
	}(_react2.default.Component);
	
	exports.default = Step2;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-recovery-password-js-7735e332e1eee4306e4f.js